import React, { Component } from "react";
import {
  FlatButton,
  Dialog,
  TextField,
  IconButton,
  Snackbar,
  CircularProgress,
} from "material-ui";
import Loading from "../Loading";
import { Link } from "react-router";
import {
  FormsyRadioGroup,
  FormsyRadio,
  FormsyText,
} from "formsy-material-ui/lib";
import Formsy from "formsy-react";
import Dropzone from "react-dropzone";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

import deleteDefaultIcon from "../../images/delete_default.png";
import editDefaultIcon from "../../images/edit_default.png";
import backIcon from "../../images/back.png";
import checkedIcon from "../../images/checked.png";
import addArrowIcon from "../../images/add_arrow.png";
import editMailingTypeIcon from "../../images/edit_mailing_type.png";
import searchIcon from "../../images/search.png";

export default class CreateMailingList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message:
        "You can also upload emails to contacts to your mailing list from a csv. Drag & Drop your email contact CSV here.",
      open: false,
      responseMsg: "",
      mailingTypeUser: {
        name: "",
        email: "",
        _id: "",
        mailingTypeId: "",
      },
      mailingType: {
        name: "",
        mailingTypeId: "",
      },
      //mailingTypeExistName: this.props.mailingType? this.props.mailingType.name: '',
      mailingTypeUserList: [],
      showToast: false,
      toastMsg: "",
      styles: {
        centerStyle: {
          marginBottom: "1em",
          marginLeft: "auto",
          marginRight: "auto",
          width: "75%",
        },
        zone: {
          width: "100%",
          height: "300px",
          border: "3px dashed #ebeff2",
        },
        activeZone: {
          width: "100%",
          height: "300px",
          border: "3px dashed green",
          backgroundColor: "Aquamarine",
        },
        zoneText: {
          textAlign: "center",
          fontSize: "2em",
        },
      },
      openDeleteConfirmPopup: false,
      currentSelectedRow: {},
      file: "",
      searchTextValue: "",
      searchText: "",
      isEmployeeEdit: false,
    };
    this.onDrop = this.onDrop.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.deleteButtonFormatter = this.deleteButtonFormatter.bind(this);
    this.editButtonFormatter = this.editButtonFormatter.bind(this);
  }

  onDrop(e) {
    if (
      e[0].name.split(".")[1] === "csv" ||
      e[0].name.split(".")[1] === "CSV"
    ) {
      this.setState({ file: e[0] });
    } else {
      this.setState({ message: `Incorrect File Type, expecting CSV` });
    }
  }

  submitForm(data) {
    if (this.state.file) {
      this.setState({ isLoading: true });
      let formData = new FormData();
      let url =
        "/api/documentUpload/uploadUser?mailingTypeId=" +
        this.state.mailingType.mailingTypeId;
      let options = {
        method: "POST",
        headers: {
          token: this.props.token,
        },
        body: formData,
      };
      formData.append("file", this.state.file);
      fetch(url, options)
        .then((response) => response.json())
        .then((json) => {
          this.setState({ response: json, isLoading: false, file: "" });
          this.getMailingTypeUserList();
        });
    } else {
      alert("File error");
      this.setState({ isLoading: false });
    }
  }

  componentDidMount() {
    this.getMailingTypeUserList();
  }

  componentWillReceiveProps(props) {
    let { mailingType, mailingTypeUserList } = this.state;
    if (Object.keys(props.mailingType).length != 0) {
      mailingType.name = props.mailingType.name;
      mailingType.mailingTypeId = props.mailingType._id;
      mailingTypeUserList = props.mailingTypeUserList;
      this.setState({
        mailingType: mailingType,
        mailingTypeUserList: mailingTypeUserList,
      });
    } else {
      mailingType.name = "";
      mailingType.mailingTypeId = "";
      this.setState({ mailingType: mailingType, mailingTypeUserList: [] });
    }
  }

  getMailingTypeUserList = (searchText) => {
    if (searchText) {
      let url =
        `/api/documentUpload/getMailingTypeUserList?mailingTypeId=` +
        this.state.mailingType.mailingTypeId +
        `&searchText=` +
        searchText;
      let options = {
        headers: {
          token: this.props.token,
        },
      };
      fetch(url, options)
        .then((res) => {
          if (res.status >= 200 && res.status < 300) return res.json();
        })
        .then((json) => {
          this.setState({
            isLoading: false,
            mailingTypeUserList: json.mailingTypeUserList,
          });
        });
    } else {
      let url =
        `/api/documentUpload/getMailingTypeUserList?mailingTypeId=` +
        this.state.mailingType.mailingTypeId;
      let options = {
        headers: {
          token: this.props.token,
        },
      };
      fetch(url, options)
        .then((res) => {
          if (res.status >= 200 && res.status < 300) return res.json();
        })
        .then((json) => {
          console.log("json.mailingTypeUserList----------", json);
          this.setState({
            isLoading: false,
            mailingTypeUserList: json.mailingTypeUserList,
          });
        });
    }
  };

  addMailingTypeUser = () => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let { mailingTypeUser, mailingType } = this.state;
    var me = this;
    if (mailingTypeUser.name == "" && mailingTypeUser.email == "") {
      alert("Name and Email should not be blank.");
    } else if (mailingTypeUser.name == "") {
      alert("Name should not be blank.");
    } else if (mailingTypeUser.email == "") {
      alert("Email should not be blank.");
    } else if (!re.test(String(mailingTypeUser.email).toLowerCase())) {
      alert("Please enter valid email.");
    } else {
      let url = `/api/documentUpload/addMailingTypeUser`;
      mailingTypeUser.mailingTypeId = mailingType.mailingTypeId;
      let options = {
        method: "POST",
        headers: {
          token: this.props.token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(mailingTypeUser),
      };
      fetch(url, options)
        .then((res) => {
          if (res.status >= 200 && res.status < 300) {
            return res.json();
          } else {
            this.notifyFormError(res, "Internal server error.");
          }
        })
        .then((json) => {
          if (json.message == "Mailing type user already exist.") {
            this.notifyFormError(json, "Mailing type user is already exist.");
          } else {
            mailingTypeUser.name = "";
            mailingTypeUser.email = "";
            mailingTypeUser.mailingTypeId = "";
            me.setState({
              mailingTypeUser: mailingTypeUser,
              showToast: true,
              toastMsg: json.message,
            });
            me.getMailingTypeUserList();
          }
        });
    }
  };

  editMailingTypeUser = () => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let { mailingTypeUser, mailingType } = this.state;
    var me = this;
    if (mailingTypeUser.name == "" && mailingTypeUser.email == "") {
      alert("Name and Email should not be blank.");
    } else if (mailingTypeUser.name == "") {
      alert("Name should not be blank.");
    } else if (mailingTypeUser.email == "") {
      alert("Email should not be blank.");
    } else if (!re.test(String(mailingTypeUser.email).toLowerCase())) {
      alert("Please enter valid email.");
    } else {
      let url = `/api/documentUpload/updateMailingTypeUser`;
      let options = {
        method: "POST",
        headers: {
          token: this.props.token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(mailingTypeUser),
      };
      fetch(url, options)
        .then((res) => {
          if (res.status >= 200 && res.status < 300) {
            return res.json();
          } else {
            this.notifyFormError(res, "Internal server error.");
          }
        })
        .then((json) => {
          if (json.message == "Mailing type user already exist.") {
            this.notifyFormError(json, "Mailing type user is already exist.");
          } else {
            mailingTypeUser.name = "";
            mailingTypeUser.email = "";
            mailingTypeUser.mailingTypeId = "";
            mailingTypeUser._id = "";
            me.setState({
              mailingTypeUser: mailingTypeUser,
              showToast: true,
              toastMsg: json.message,
            });
            me.getMailingTypeUserList();
          }
        });
    }
  };
  resetEmployeeField = () => {
    this.setState({
      isEmployeeEdit: false,
      mailingTypeUser: { _id: "", name: "", email: "", mailingTypeId: "" },
    });
  };
  onMailingTypeUserChangeValue = (key, value) => {
    let { mailingTypeUser } = this.state;
    if (key == "name") {
      mailingTypeUser.name = value;
    } else {
      mailingTypeUser.email = value;
    }
    this.setState({ mailingTypeUser: mailingTypeUser });
  };

  onChangeValue = (value) => {
    let { mailingType } = this.state;
    mailingType.name = value;
    this.setState({ mailingType: mailingType });
  };

  createMailing = () => {
    let { mailingType, mailingTypeUser } = this.state;
    var me = this;
    if (mailingType.name == "") {
      alert("Name should not be blank.");
    } else {
      let url = `/api/documentUpload/addMailingType`;
      let body = mailingType;
      let options = {
        method: "POST",
        headers: {
          token: this.props.token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(mailingType),
      };
      fetch(url, options)
        .then((res) => {
          if (res.status >= 200 && res.status < 300) return res.json();
        })
        .then((json) => {
          if (json.message == "Mailing type already exist.") {
            this.notifyFormError(json, "Mailing type is already exist.");
          } else {
            mailingType.name = json.mailing_type.name;
            mailingType.mailingTypeId = json.mailing_type._id;
            me.setState({
              mailingType: mailingType,
              showToast: true,
              toastMsg: json.message,
            });
          }
        });
    }
  };

  editMailingType = () => {
    let { mailingType, mailingTypeUser } = this.state;
    var me = this;
    if (mailingType.name == "") {
      alert("Name should not be blank.");
    } else {
      let url =
        `/api/documentUpload/editMailingType?mailingTypeId=` +
        mailingType.mailingTypeId;
      let body = mailingType;
      let options = {
        method: "POST",
        headers: {
          token: this.props.token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(mailingType),
      };
      fetch(url, options)
        .then((res) => {
          if (res.status >= 200 && res.status < 300) return res.json();
        })
        .then((json) => {
          if (json.message == "Mailing type already exist.") {
            this.notifyFormError(json, "Mailing type is already exist.");
          } else {
            mailingType.name = json.mailing_type.name;
            mailingType.mailingTypeId = json.mailing_type._id;
            me.setState({
              mailingType: mailingType,
              showToast: true,
              toastMsg: json.message,
              mailingTypeExistName: json.mailing_type.name,
            });
          }
        });
    }
  };

  notifyFormError(data, msg) {
    alert(msg);
  }

  deleteMailingTypeListUser = (row) => {
    this.setState({ currentSelectedRow: row, openDeleteConfirmPopup: true });
  };

  editMailingTypeListUser = (row) => {
    let { mailingTypeUser, mailingType } = this.state;
    mailingTypeUser.name = row.name;
    mailingTypeUser.email = row.email;
    mailingTypeUser._id = row._id;
    mailingTypeUser.mailingTypeId = mailingType.mailingTypeId;
    this.setState({ mailingTypeUser: mailingTypeUser, isEmployeeEdit: true });
  };

  deleteConfirmPopupClick = () => {
    let { mailingType, currentSelectedRow } = this.state;
    var me = this;
    let url =
      `/api/documentUpload/deleteMailingTypeUser?mailingTypeId=` +
      mailingType.mailingTypeId;
    let body = currentSelectedRow;
    let options = {
      method: "POST",
      headers: {
        token: this.props.token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        this.setState({
          currentSelectedRow: {},
          openDeleteConfirmPopup: false,
        });
        if (json.message == "Mailing type user not exist.") {
          this.notifyFormError(json, "Mailing type user is not exist.");
        } else {
          me.getMailingTypeUserList();
        }
      });
  };

  // This method is used for searching
  submitSearchForm(searchText) {
    let { mailingType, mailingTypeUserList } = this.state;
    var me = this;
    if (searchText != "" && searchText != null) {
      this.getMailingTypeUserList(searchText.trim());
      this.setState({ isLoading: false, searchTextValue: searchText });
    } else {
      this.setState({ searchTextValue: "" });
      let rowData = {
        _id: mailingType.mailingTypeId,
        name: mailingType.name,
        mailTypeUser: mailingTypeUserList,
      };
      this.props.navigation(rowData, "CREATE_MAILING_LIST", "");
    }
  }

  deleteButtonFormatter(cell, row) {
    return (
      <IconButton
        onClick={() => {
          this.deleteMailingTypeListUser(row);
        }}
        style={{ width: "25px", height: "25px" }}
      >
        <img src={deleteDefaultIcon} />
      </IconButton>
    );
  }

  editButtonFormatter(cell, row) {
    return (
      <IconButton
        onClick={() => {
          this.editMailingTypeListUser(row);
        }}
        style={{
          width: "25px",
          height: "25px",
          padding: "0px",
          paddingLeft: "15px",
        }}
      >
        <img src={editDefaultIcon} />
      </IconButton>
    );
  }

  clearSearchText() {
    this.setState({ searchTextValue: "" });
  }

  renderMailingTypeUserListTable() {
    if (this.state.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={"#424242"} />
          </center>
        </div>
      );
    } else {
      let { mailingTypeUserList } = this.state;
      console.log("mailingTypeUserList----------", mailingTypeUserList);
      return (
        <div style={{ overflowY: "inherit", width: "95%", margin: "0 auto" }}>
          <div>
            <div>
              <div className="searchTextCls">
                <input
                  type="text"
                  value={this.state.searchTextValue}
                  className="searchInputCls"
                  placeholder="Search"
                  onChange={(e) => this.submitSearchForm(e.target.value)}
                />
                <span
                  className="searchImgCls"
                  onClick={() => {
                    this.clearSearchText();
                  }}
                >
                  <img src={searchIcon} style={{ width: "16px" }} />
                </span>
              </div>
            </div>
            <BootstrapTable
              data={mailingTypeUserList}
              bordered={false}
              pagination
            >
              <TableHeaderColumn
                isKey={true}
                dataField="_id"
                width="120"
                hidden={true}
              >
                Id
              </TableHeaderColumn>
              <TableHeaderColumn dataField="name" width="80">
                Name
              </TableHeaderColumn>
              <TableHeaderColumn dataField="email" width="120">
                Email
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="button"
                dataFormat={this.editButtonFormatter}
                width="20"
              ></TableHeaderColumn>
              <TableHeaderColumn
                dataField="button"
                dataFormat={this.deleteButtonFormatter}
                width="20"
              ></TableHeaderColumn>
            </BootstrapTable>
          </div>
        </div>
      );
    }
  }

  showMailingList = () => {
    this.setState({
      searchTextValue: "",
      isEmployeeEdit: false,
      mailingType: { name: "", email: "" },
    });
    this.props.showMailingListMethod();
  };

  handleToastClose = () => {
    this.setState({ showToast: false, toastMsg: "" });
  };

  renderContent() {
    let { response, isLoading } = this.state;
    let { zone, activeZone, centerStyle } = this.state.styles;
    let filter = { type: "TextFilter", delay: 500 };

    if (isLoading) {
      let size = window.screen.width / 7;
      return <CircularProgress color={"#424242"} size={size} thickness={20} />;
    }
    return (
      <div style={{ padding: "2rem" }}>
        <Dropzone
          onDrop={this.onDrop}
          disablePreview={true}
          style={zone}
          activeStyle={activeZone}
        >
          <center>
            <h4 className="uploadAttachmentTextAlign">
              {this.state.file ? this.state.file.name : this.state.message}
            </h4>
          </center>
        </Dropzone>
      </div>
    );
  }

  closeDeleteConfirmPopup = () => {
    this.setState({ openDeleteConfirmPopup: false });
  };

  resetForm = () => {
    this.setState({ file: "", response: "", isLoading: false });
  };

  render() {
    let {
      mailingType,
      mailingTypeUser,
      showToast,
      toastMsg,
      openDeleteConfirmPopup,
      mailingTypeExistName,
      isEmployeeEdit,
    } = this.state;
    let { open } = this.props;
    console.log("mailingType---------", mailingType);
    return (
      <div style={{ display: open ? "block" : "none", margin: "1em" }}>
        <Snackbar
          style={{ bottom: "none", backgroundColor: "green" }}
          open={false}
          autoHideDuration={6000}
          message={toastMsg}
        />
        <div style={{ minHeight: "calc(100vh - 40px)" }}>
          <div className="row">
            <div
              className="column d-flex align-items-stretch"
              style={{ backgroundColor: "#fff" }}
            >
              <div style={{ width: "100%" }}>
                <div
                  className="addCompanyHeader"
                  style={{ display: "flex", margin: "0px" }}
                >
                  <div
                    style={{
                      marginTop: "-0.5rem",
                      marginLeft: "-2rem",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{ display: "inline-block", width: "10%" }}
                      className="genericUploaderBackIconCls"
                    >
                      <IconButton
                        aria-label="close"
                        style={{ width: "25px" }}
                        onClick={this.showMailingList}
                      >
                        <img
                          src={backIcon}
                          style={{
                            width: "16px",
                            marginRight: "5px",
                            marginTop: "-5px",
                          }}
                        />
                      </IconButton>
                    </div>
                    <div
                      style={{
                        display: "inline-block",
                        width: "80%",
                        textAlign: "center",
                      }}
                    >
                      <span>
                        {mailingType.mailingTypeId != ""
                          ? "Update Mailing List"
                          : "Create Mailing List"}
                      </span>
                    </div>
                  </div>
                </div>
                <div>
                  <div style={{ marginLeft: "1rem" }}>
                    <div>
                      <TextField
                        floatingLabelText="Mailing Title"
                        value={this.state.mailingType.name}
                        style={{ width: "24rem" }}
                        onChange={(e) => this.onChangeValue(e.target.value)}
                      />
                      {mailingType.mailingTypeId != "" ? (
                        mailingTypeExistName == mailingType.name ? (
                          <IconButton
                            aria-label="edit"
                            onClick={() => {
                              this.editMailingType();
                            }}
                            style={{ width: "25px" }}
                          >
                            <img
                              src={editMailingTypeIcon}
                              className="opacityImg"
                            />
                          </IconButton>
                        ) : (
                          <IconButton
                            aria-label="edit"
                            onClick={() => {
                              this.editMailingType();
                            }}
                            style={{ width: "25px" }}
                          >
                            <img src={checkedIcon} className="opacityImg" />
                          </IconButton>
                        )
                      ) : mailingType.name != "" ? (
                        <IconButton
                          aria-label="create"
                          onClick={() => {
                            this.createMailing();
                          }}
                          style={{ width: "25px" }}
                        >
                          <img src={checkedIcon} className="opacityImg" />
                        </IconButton>
                      ) : null}
                    </div>
                    <div>
                      <TextField
                        floatingLabelText="Id"
                        value={mailingTypeUser._id}
                        disabled={true}
                      />
                      <TextField
                        floatingLabelText="Name"
                        value={mailingTypeUser.name}
                        disabled={!mailingType.mailingTypeId}
                        style={{ width: "24rem" }}
                        onChange={(e) =>
                          this.onMailingTypeUserChangeValue(
                            "name",
                            e.target.value,
                          )
                        }
                      />
                      <TextField
                        floatingLabelText="Email"
                        value={mailingTypeUser.email}
                        disabled={!mailingType.mailingTypeId}
                        style={{ width: "24rem" }}
                        onChange={(e) =>
                          this.onMailingTypeUserChangeValue(
                            "email",
                            e.target.value,
                          )
                        }
                      />
                    </div>

                    {isEmployeeEdit ? (
                      <div style={{ float: "right", marginRight: "2rem" }}>
                        <FlatButton
                          disabled={!mailingType.mailingTypeId}
                          onClick={this.resetEmployeeField}
                          className="flatButtonCls"
                        >
                          Reset
                        </FlatButton>
                        <FlatButton
                          disabled={!mailingType.mailingTypeId}
                          onClick={this.editMailingTypeUser}
                          className="flatButtonCls"
                          style={{ marginLeft: "5px" }}
                        >
                          <img src={addArrowIcon} /> Update
                        </FlatButton>
                      </div>
                    ) : (
                      <div style={{ float: "right", marginRight: "2rem" }}>
                        <FlatButton
                          disabled={!mailingType.mailingTypeId}
                          onClick={this.addMailingTypeUser}
                          className="flatButtonCls"
                        >
                          <img src={addArrowIcon} /> Add
                        </FlatButton>
                      </div>
                    )}
                  </div>
                  <br />
                  <hr />
                  {this.renderMailingTypeUserListTable()}
                </div>
              </div>
            </div>
            <div className="column d-flex align-items-stretch rightMainDiv">
              <div>
                <Formsy.Form
                  ref="form"
                  onValidSubmit={this.submitNoteForm}
                  onInvalidSubmit={this.notifyFormError}
                >
                  <FormsyText
                    multiLine
                    name="note"
                    placeholder="Note..."
                    InputProps={{ disableUnderline: true }}
                    style={{
                      width: "93%",
                      marginLeft: "2rem",
                      marginBottom: "0",
                      height: "70px",
                      border: "1px solid #ccc",
                      padding: "10px",
                      marginTop: "0px",
                      maxHeight: "90px",
                    }}
                  />
                </Formsy.Form>
              </div>
              {this.renderContent()}
              <div
                style={{
                  float: "right",
                  marginTop: "1rem",
                  right: "30px",
                  bottom: "20px",
                }}
              >
                <FlatButton
                  disabled={this.state.isLoading}
                  onClick={this.resetForm}
                  className="flatButtonCls"
                >
                  Reset
                </FlatButton>
                <FlatButton
                  disabled={this.state.mailingType.mailingTypeId ? false : true}
                  onClick={this.submitForm}
                  style={{ marginLeft: "2rem" }}
                  className="flatButtonCls"
                >
                  Submit
                </FlatButton>
              </div>
            </div>
          </div>
        </div>
        <Dialog
          title="Delete User"
          open={openDeleteConfirmPopup}
          onRequestClose={this.closeDeleteConfirmPopup}
          style={{ width: "50%", textAlign: "center" }}
        >
          Are you sure you want to delete this user?
          <br />
          <br />
          <FlatButton
            type="button"
            className="flatButtonCls"
            onTouchTap={this.deleteConfirmPopupClick}
          >
            Yes
          </FlatButton>
          <FlatButton
            type="button"
            style={{ marginLeft: "2rem" }}
            className="flatButtonCls"
            onTouchTap={this.closeDeleteConfirmPopup}
          >
            No
          </FlatButton>
        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/documentUploader/CreateMailingList.js